import { Search } from "lucide-react";

export function RegisterSearch({
  value,
  onChange,
  onSearch,
  placeholder,
  testId,
  ariaLabel = "Search",
  maxLength = 50,
}) {
  function handleKeyDown(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      onSearch?.();
    }
  }

  return (
    <label className="hx-register-search">
      <button type="button" className="hx-search-submit" onClick={onSearch} aria-label={ariaLabel}>
        <Search size={15} />
      </button>
      <input
        data-testid={testId}
        maxLength={maxLength}
        placeholder={placeholder}
        value={value}
        onChange={(event) => onChange?.(event.target.value.slice(0, maxLength))}
        onKeyDown={handleKeyDown}
      />
      <kbd className="absolute right-2.5 top-1/2 -translate-y-1/2 hidden sm:inline-flex items-center gap-0.5 px-1.5 py-0.5 text-[9px] font-sans font-medium text-slate-400 bg-slate-100 border border-slate-200 rounded select-none pointer-events-none">
        Enter
      </kbd>
    </label>
  );
}
